import { render, staticRenderFns } from "./AplusReward.vue?vue&type=template&id=6a81a569&scoped=true&"
import script from "./AplusReward.vue?vue&type=script&lang=js&"
export * from "./AplusReward.vue?vue&type=script&lang=js&"
import style0 from "./AplusReward.vue?vue&type=style&index=0&id=6a81a569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81a569",
  null
  
)

export default component.exports